<template>
  <div
    class="emission_wrap"
    @mouseenter="mouseEnter"
    @mouseleave="mouseLeave"
    ref="emission"
  >
    <button
      v-if="customerId == 37"
      ref="hideBtn"
      @click="
        (e) => {
          hideEmission(e);
        }
      "
      class="hide_btn isHide"
    >
      {{ buttonVal }}
    </button>
    <div class="emission_bg"></div>
    <div class="emission_box">

      <div class="allCount number">{{ listData?.count }}</div>
      <ul class="bar_box">
        <li class="everyli" v-for="(item, i) in listData?.typeCount" :key="i">
          <div v-if="item?.name && item?.count">
            <!-- <div> -->
            <span class="listName">{{ item?.name }}</span>
            <span class="listCount number count">{{ item?.count }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["matrix", "x", "y"],
  data() {
    return {
      pageInfo: 'emission_new.vue',
      computedName: '排放源清单管理组件',
      customerId: this.$store.state.customerId,
      listData: { count: 0, type: [], typeCount: [] },
      emission_active: false,
      buttonVal: "隐藏",
    };
  },
  mounted() {
    let that = this;
    let w = $(that.$refs.emission).outerWidth();
    let h = $(that.$refs.emission).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getListData();
    window.emissionShow = true;
    if (this.customerId == 37) {
      if (window.emissionShow) {
        this.buttonVal = "隐藏";
        $(this.$refs.emission).find(".emission_bg").show();
        $(this.$refs.emission).find(".emission_box").show();
        $(this.$refs.emission).parent().find(".titleMod").show();
      } else {
        this.buttonVal = "显示";
        $(this.$refs.emission).find(".emission_bg").hide();
        $(this.$refs.emission).find(".emission_box").hide();
        $(this.$refs.emission).parent().find(".titleMod").hide();
      }
    }
  },
  methods: {
    mouseEnter() {
      if (this.$refs.hideBtn && $(this.$refs.hideBtn).length > 0) {
        $(this.$refs.hideBtn).removeClass("isHide");
        $(this.$refs.hideBtn).addClass("isShow");
      }
    },
    mouseLeave() {
      if (this.$refs.hideBtn && $(this.$refs.hideBtn).length > 0) {
        $(this.$refs.hideBtn).removeClass("isShow");
        $(this.$refs.hideBtn).addClass("isHide");
      }
    },
    hideEmission(event) {
      if (event && event.stopPropagation) {
        event.stopPropagation();
      }
      if (this.$refs.emission && $(this.$refs.emission).length > 0) {
        if ($(this.$refs.emission).find(".emission_bg").is(":visible")) {
          this.buttonVal = "显示";
          window.emissionShow = false;
          $(this.$refs.emission).find(".emission_bg").hide();
          $(this.$refs.emission).find(".emission_box").hide();
          $(this.$refs.emission).parent().find(".titleMod").hide();
        } else {
          this.buttonVal = "隐藏";
          window.emissionShow = true;
          $(this.$refs.emission).find(".emission_bg").show();
          $(this.$refs.emission).find(".emission_box").show();
          $(this.$refs.emission).parent().find(".titleMod").show();
        }
      }
    },
    async getListData() {
      let findInventory = CONFIG.requestName + this.$apiOpt.findInventory;
      let res = await this.$apiUtils.get(findInventory, {
        customerId: this.customerId,
      });
      if (res) {
        // for (var a = 0; a < res.typeCount.length; a++) {
        // if (
        //   res.typeCount.findIndex(
        //     (e) => Boolean(e.name) == false || Boolean(e.typeId) == false
        //   ) != -1
        // ) {
        //   res.typeCount.splice(
        //     res.typeCount.findIndex(
        //       (e) => Boolean(e.name) == false || Boolean(e.typeId) == false
        //     ),
        //     1
        //   );
        // } else {
        //   break;
        // }
        // }
        this.listData = res;
        if (res?.typeCount?.length == 3) {
          $(".emission_bg").removeClass("emission_bg").addClass("emission_bg2");
          $(".bar_box").css({ paddingTop: "23px", paddingBottom: "16px" });
          $(".everyli").css("height", "33%");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.emission_wrap {
  height: 250px;
  width: 600px;
  cursor: pointer;
  .hide_btn {
    font-size: 28px;
    padding: 2px 10px;
    z-index: 99;
    position: absolute;
    top: 0px;
    left: 0px;
  }
  .isHide {
    visibility: hidden;
  }
  .isShow {
    visibility: visible;
  }
  .emission_bg {
    position: absolute;
    bottom: 20px;
    @include bg-box(560px, 178px, "emissionBg.png");
    pointer-events: none;
  }
  .emission_box {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    margin-top: 33px;
    .allCount {
      width: 50%;
      font-size: 28px;
      font-weight: 400;
      color: #ffffff;
      line-height: 180px;
      z-index: 2;
      text-align: center;
    }
    .bar_box {
      width: 50%;
      display: flex;
      flex-wrap: wrap;
      padding-left: 40px;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-right: 20px;
      .everyli {
        width: 100%;
        height: 25%;
        div {
          text-align: left;
          align-items: center;
          display: flex;
          justify-content: space-between;
          height: 100%;
          .listName {
            z-index: 2;
            height: 16px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(224, 224, 224, 1);
            line-height: 16px;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
.emission_bg2 {
  position: absolute;
  bottom: 20px;
  @include bg-box(560px, 178px, "emissionBg2.png");
  pointer-events: none;
}
</style>
<style scoped>
.count {
  z-index: 2;
  height: 28px;
  font-size: 28px;
  font-weight: 400;
  /* color: #5f4cdf; */
  line-height: 28px;
}
li:nth-child(1) .count {
  color: rgba(95, 76, 223, 1) !important;
}
li:nth-child(2) .count {
  color: rgba(70, 119, 212, 1) !important;
}
li:nth-child(3) .count {
  color: rgba(75, 198, 255, 1) !important;
}
li:nth-child(4) .count {
  color: rgba(59, 248, 216, 1) !important;
}
</style>
